import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import furnitureReducer from "./furnitureSlice";
import gameReducer from "./gameSlice";
import obstaclesReducer from "./obstaclesSlice";

export const store = configureStore({
  reducer: {
    grab: obstaclesReducer,
    furniture: furnitureReducer,
    game: gameReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
